import ValueObject from './ValueObject';

export default class ServiceRegionId extends ValueObject {
  equals(other) {
    if (!(other instanceof ServiceRegionId)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new ServiceRegionId(json);
  }
}
